import { useEffect } from 'react';
import { useLocation } from 'react-router';

/** Start a page at the top when arriving from a link lower down another page (unless it targets an anchor). */
export function useScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
}
